
import { Vue } from "vue-class-component";

export default class ProfileGray extends Vue {}
